document.addEventListener('DOMContentLoaded', function () {
    const toggleBtn = document.querySelector('.track-spec-btn');
    const allSpecRows = document.querySelectorAll('.product-track-spec .product-spec__row');

    // 无按钮直接终止
    if (!toggleBtn) return;

    toggleBtn.addEventListener('click', function () {
        const seventhRow = allSpecRows[6];
        const isExpanded = !seventhRow.classList.contains('row-hide');

        allSpecRows.forEach((row, index) => {
            if (isExpanded) {
                // 收起：7行及以后加隐藏类
                if (index >= 6) row.classList.add('row-hide');
            } else {
                // 展开：全部移除隐藏类，下拉缓动出现
                row.classList.remove('row-hide');
            }
        });

        // 切换按钮open类，控制箭头180度旋转
        toggleBtn.classList.toggle('open');
    });
});